// ? all elements predefined where null... needs testing

const searchProducts = {
    initialState() {
        const searchBar = document.querySelector('.product-filter-form > input');

        if (searchBar) {
            searchBar.addEventListener('input', (event) => { this.fetchResults(event); })
        }
    },
    fetchResults({ target }) {
        const language = document.querySelector('html').getAttribute('lang');

        fetch(`${window.location.pathname}?get-products=${target.value}&lang=${language}`)
        .then(res => res.json())
        .then(data => searchProducts.renderResults(data))
        .catch(err => {
            throw new Error(`${target} element failed to fetch`, { cause: err });
        });
    },
    renderResults(data) {
        const renderArea = document.querySelectorAll('.products-list-section');
        let renderContent, wordMatches, wordMatch, wordMatchRefs, wordMatchRef, li;

        renderArea.forEach(area => { area.innerHTML = ''; });

        if (Object.keys(data).length !== 0) {
            const error = document.querySelector('.no-products');
            error.classList.add('hide');

            for (let section of Object.keys(data)) {

                wordMatches = Object.keys(data[section]); // * Array [ "A", "B", "C", "D", "E", "F", "G" ]
                wordMatches.forEach(word => {
                    renderContent = document.createElement('section');
                    renderContent.classList.add('render-content');

                    wordMatch = document.createElement('h2');
                    wordMatch.classList.add('word-match');
                    wordMatch.append(word);

                    wordMatchRef = document.createElement('ul');
                    wordMatchRef.classList.add('word-match-ref');
                    wordMatchRefs = data[section][word]; // * Array [ "UN Packages", "Urea", "Urea Solution" ]
                    wordMatchRefs.forEach(ref => {
                        li = document.createElement('li');
                        li.append(ref);
                        wordMatchRef.append(li);
                    });
                    renderContent.append(wordMatch);
                    renderContent.append(wordMatchRef);
                    renderArea[section - 1].append(renderContent);
                })
            }
        } else {
            const error = document.querySelector('.no-products');
            error.classList.remove('hide');
        }
    }
}

export default searchProducts;